import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Tpl3plService } from '../../services/tpl3pl.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

export interface InboundResendPreviewDialogData {
	orderNo: string;
	forceResend?: boolean;
	onSent?: () => void;
}

@Component({
	selector: 'app-tpl3pl-inbound-resend-preview-dialog',
	templateUrl: './tpl3pl-inbound-resend-preview-dialog.component.html',
})
export class Tpl3plInboundResendPreviewDialogComponent implements OnInit {
	loading = true;
	sending = false;
	error: string | null = null;
	preview: {
		success: boolean;
		skipped?: boolean;
		message?: string;
		orderno: string;
		supplier_id?: string;
		supplier_name?: string;
		payload?: any;
		sku_check?: { sku: string; description: string; qty: number; in_3pl: boolean }[];
		total_skus?: number;
		all_skus_ready?: boolean;
		missing_count?: number;
	} | null = null;

	constructor(
		public dialogRef: MatDialogRef<Tpl3plInboundResendPreviewDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: InboundResendPreviewDialogData,
		private tpl3plService: Tpl3plService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.loadPreview();
	}

	loadPreview(): void {
		this.loading = true;
		this.error = null;
		this.preview = null;
		this.tpl3plService.previewInboundPo(this.data.orderNo).subscribe({
			next: (res) => {
				this.loading = false;
				if (res.success) {
					this.preview = res;
				} else {
					this.error = res.message || 'Could not build preview';
				}
			},
			error: (err) => {
				this.loading = false;
				this.error = err?.error?.message || err?.message || 'Preview failed';
			}
		});
	}

	send(): void {
		if (this.sending) { return; }
		this.sending = true;
		this.tpl3plService.sendInboundPo(this.data.orderNo, !!this.data.forceResend).subscribe({
			next: (res) => {
				this.sending = false;
				const msg = res.success
					? (res.skipped ? (res.message || 'No in-scope lines — inbound not sent') : (res.message || 'Inbound sent'))
					: (res.message || 'Send failed');
				this.globalSearchService.showNotification(msg, res.success ? 'success' : 'danger', 'bottom', 'right');
				if (res.success) {
					if (this.data.onSent) { this.data.onSent(); }
					this.dialogRef.close({ success: true });
				}
			},
			error: (err) => {
				this.sending = false;
				const msg = err?.error?.message || err?.message || 'Send failed';
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			}
		});
	}

	get missingCount(): number {
		return this.preview?.missing_count ?? 0;
	}

	get allReady(): boolean {
		return !!this.preview?.all_skus_ready;
	}

	close(): void {
		this.dialogRef.close();
	}
}
